module.exports = __webpack_public_path__ + "static/media/vertical-master-3.6abe9344.svg";